















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Moment, isMoment } from 'moment';
import moment = require('moment');
const views = ['minutes', 'hours', 'days', 'months', 'years'];

const validatorView = function (value: string): boolean {
  return views.indexOf(value) !== -1;
};

@Component({
  name: 'ui-date-time',
})
export default class UiDateTime extends Vue {
  @Prop({ default: () => new Date(), type: Date }) date: Date;
  @Prop({ default: () => new Date(), type: Date }) dateSecond: Date;
  @Prop({ default: null, type: Date }) minimumDate: Date;
  // ограничение даты сверху
  @Prop({ default: null, type: Date }) maximumDate: Date;
  @Prop({ type: String, validator: validatorView }) initialView: String;
  @Prop({ default: 'years', type: String, validator: validatorView }) minimumView: string;
  @Prop({ default: 'months', type: String, validator: validatorView }) maximumView: string;
  @Prop({ default: null, type: String }) linkedDatePickerName: String;
  @Prop({ default: false, type: Boolean }) isDateRange: boolean;
  @Prop({ default: () => [] }) eventDates: Array<any>;
  @Prop({ default: true }) showCurrentDate: boolean;

  innerCurrentView = this.getInitialView();
  innerDay: number = this.date.getDate();
  innerMonth: number = this.date.getMonth();
  innerYear: number = this.date.getFullYear();
  innerHour: number = this.date.getHours();
  innerMinute: number = this.date.getMinutes();
  innerDate: Date = this.date;
  linkedDatePicker = this.linkedDatePickerName;
  created() {
    this.validateViewRanges();
  }
  mounted() {
    this.linkedDatePicker = this.linkedDatePickerName;
  }
  @Watch('maximumView')
  @Watch('minimumView')
  validateViewRanges() {
    var invalid = views.indexOf(this.minimumView) > views.indexOf(this.maximumView);
    if (invalid) {
      console.error(`Maximumview не может быть меньше minimumView. Maximumview=${this.maximumView}, minimumview=${this.minimumView}`);
    }
  }
  @Watch('minDate')
  ChangeMinDate() {
    if (this.linkedDatePicker) {
      return this.linkedDatePicker;
    }
    return this.minimumDate;
  }

  getDate() {
    return new Date(this.innerYear, this.innerMonth, this.innerDay);
  }

  NavigatorDatetime(typeView: any) {
    if (this.allowedToShowView(typeView)) {
      this.innerCurrentView = typeView;
    }
  }

  ChangeDatetime(date: Date, typeView: any, type: string) {
    this.innerDate = date;
    this.$emit('change', date, type);
    if (this.allowedToShowView(typeView)) {
      this.ChangeCurrentView(typeView);
    }
  }
  /**
   * Изменить текущее представление
   */
  ChangeCurrentView(typeView: any) {
    this.innerCurrentView = typeView;
  }

  getInitialView(): String {
    if (!this.initialView) return this.maximumView;
    return this.initialView;
  }
  /**
   * Разрешено ли открытие представления
   */
  allowedToShowView(view: any) {
    // debugger
    let minimumViewIndex = views.indexOf(this.minimumView);
    let maximumViewIndex = views.indexOf(this.maximumView);
    let viewIndex = views.indexOf(view);
    return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
  }
  getRequest() {
    return this.date;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-date-picker/src/ui-date-time.vue